import React from "react";
import {compose} from "recompose";
import {withFirestore} from "../../firebase/context";
import Button from "@material-ui/core/Button/Button";
import {confirmAlert} from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

class DataList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: '',
            foodList: []
        }
    }

    componentDidMount() {
        this.setState({loading: true});
        this.listener = this.props.firestore.foods().orderBy("koreanId").onSnapshot((snapshot => {
            let foodList = [];
            snapshot.forEach(doc =>
                foodList.push({...doc.data(), id: doc.id}),
            );
            this.setState({
                foodList: foodList,
                loading: false,
            });
        }))


    }

    componentWillUnmount() {
        if (this.listener != null && this.listener.type === 'function') {
            this.listener.off();
        }
    }

    confirmDelete = (food) => {
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure you want to delete: ' + food.name,
            buttons: [
                {
                    label: 'Confirm',
                    onClick: () => this.handleDelete(food)
                },
                {
                    label: 'Cancel',
                    onClick: () => console.log('Delete cancelled')
                }
            ]
        });
    };

    async handleDelete(food) {

        this.props.firestore.foods().doc(food.id).delete()
            .then(() => {
                console.log("Successfully deleted item");
            }).catch((error) => {
            console.error("Error removing document: ", error);
        });

        this.props.firestore.imageStorage(food.koreanId).delete()
            .then((result) => {
                console.log("Successfully deleted item image");
            }).catch((error) => {
            console.error("Error removing document: ", error);
        });


    }


    render() {
        const {loading} = this.state;
        if (loading) {
            return (
                <div className="flex_column" style={{justifyContent: 'center', alignItems: 'center'}}>
                    Loading
                </div>
            )
        }


        const {foodList} = this.state;
        return (
            <div className="flex_column" style={{padding: 20}}>
                <div className="flex_row" style={{borderBottom: 'solid', paddingBottom: '8px', marginBottom: '8px'}}>
                    <div className="flex_column">Korean id</div>
                    <div className="flex_column">Name</div>
                    <div className="flex_column">Category</div>
                    <div className="flex_column">Price level</div>
                    <div className="flex_column">Spicy</div>
                    <div className="flex_column">Veggie</div>
                    <div className="flex_column">Delete</div>
                </div>

                {foodList.map((food, index) =>
                    <div key={index} className="flex_row" style={{marginBottom: 20}}>
                        <div className="flex_row">
                            <div className="flex_column">{food.koreanId}</div>
                            <div className="flex_column">{food.name}</div>
                            <div className="flex_column">{food.category}</div>
                            <div className="flex_column">{food.priceLevel}</div>
                            <div className="flex_column">{food.spicy.toString()}</div>
                            <div className="flex_column">{food.veggie.toString()}</div>
                            <div className="flex_column">
                                <Button onClick={(event) => this.confirmDelete(food)}>
                                    Delete
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}


export default compose(
    withFirestore,
)(DataList);
